/**
 * The "idLabel" property should be used as the main view identifier everywhere.
 * When it is not defined, we'll fallback to the view "id".
 */
export function getViewId(view) {
  return view.idLabel || view.id;
}